<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-3/4 lg:w-4/5 m-12">
      <vx-card>

        <div class="vx-card__title mb-12">
          <h4 class="text-center">
            Cette page vous adira afin de configurer les diverses composantes nécessaires afin de rendre le Super-Rep fonctionnel.
          </h4>
          <br>
          <p>
            <b style="color:red">ATTENTION</b>: si vous n'êtes pas 100% familier avec les termes et configurations détaillés sur cette page, veuillez nous en informer.
            Ne tentez pas de modifier vos paramètres DNS si vous n'êtes pas 100% certain de ce que vos faites!
            Une mauvaise configuration DNS peut avoir un impact à la fois sur votre <b> site Web</b>, ainsi que sur la
            <b>réception de vos courriels</b>
          </p>          <br>
          <p>
            Il nous fera grand plaisir de vous assister via Zoom, ou de faire ces changements pour vous.
          </p>
        </div>

        <vs-divider position="center"></vs-divider>


        <h1></h1>
        <vs-table :data="records">
          <template slot="header">
            <h3>
              DNS ZONE : {{ domain }}
            </h3>
          </template>
          <template slot="thead">
            <vs-th>
              Nom
            </vs-th>
            <vs-th>
              Type
            </vs-th>
            <vs-th>
              Valeur actuelle
            </vs-th>
            <vs-th>
              Valeur Désirée
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="(tr, indextr) in data" :key="indextr" :state="tr.isValid ?'success':'danger'">
              <vs-td>
                {{ tr.domain }}
              </vs-td>

              <vs-td>
                {{ tr.type }}
              </vs-td>

              <vs-td style="width: 500px; overflow-wrap: anywhere;">
                {{ tr.currentValue }}
              </vs-td>

              <vs-td style="width: 500px; overflow-wrap: anywhere;">
                {{ tr.expectedValue }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>


<script>

import axios from 'axios'
import { parseDomain } from 'parse-domain'

export default {

  data ()
  {
    return {
      records:   [],
      lookupURL: 'https://api.toolbox.newera.systems/config/dns/lookup/',
    }
  },
  computed:
    {
      domain ()
      {
        return this.$route.params.domainName
      },

      baseDomain ()
      {
        const { subDomains, domain, topLevelDomains } = parseDomain(
          // This should be a string with basic latin characters only.
          // More information below.
          this.domain,
        )
        return domain
      }

    },

  components: {},
  mounted ()
  {
    this.records = []

    this.txtSPF()
    this.cnameBAP()
    this.cnameCOMMUNICATIONS()
    this.cnameEMAILS()
    this.txtDKIM()
  },
  methods:    {

    txtSPF ()
    {
      axios.get(this.lookupURL + 'txt/' + this.domain).then(response => {
        let valid        = false
        let currentValue = '[NOT SET]'
        response.data.forEach(data => {
          if (data.txt && data.txt.startsWith('v=spf1'))
          {
            currentValue = data.txt
          }

        })

        let expectedValue = currentValue.replace('v=spf1 ', 'v=spf1 include:spf.newera.systems ')

        if (currentValue.includes('include:spf.newera.systems '))
        {
          valid         = true
          expectedValue = currentValue
        }

        let txtSPF = {
          isValid:       valid,
          domain:        this.domain,
          type:          'TXT',
          currentValue:  currentValue,
          expectedValue: expectedValue,
        }

        this.records.push(txtSPF)
      })
    },
    txtDKIM ()
    {
      let expectedValue = '[WILL BE PROVIDED]'
      let key           = '[WILL BE PROVIDED]'
      if (this.baseDomain === 'mp-plus')
      {
        key           = 'smtp._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCt4cLe6ybv+qPEVQK3gUqEbVJcLsL70cjbRBn4vQ1DHC8vsKgTKyxlontolRNWUJgl/b8RFGrRCsoLHxrIdmSudW5PMds7YRV9WHWA/EV93iR3XR+SlM8a/PUmoYNPG+9QLY8ZkGES9JLoBq6v4L/ZyQZkv4C0yCV5KL5U2YG/fQIDAQAB'
      }

      if (this.baseDomain === 'grouperp')
      {
        key           = 'k1._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC4Dd21Y9EHyKVpaNu/57iVD4h5HUTmWWuWT3LC+RDtf2d7RZJ82V0QODTUt1rmFO1kpeGddjMhvDsh62hcfX3XsHj7x7TaGBhe1dTb+kYkDl8HrfKHg27ZTjutRcURdV8MG1rRNki4YB4+yxh58Or61ZDcTjoCYSrYh0xdO+5VuQIDAQAB'
      }

      if (this.baseDomain === 'lepresent')
      {
        key           = 'k1._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDkVdfhfXibghuN/8mVRAkwDD6CAUbY41/JkYa76W35Lp4iM2OUVi0uXHWQ4qHMHOJPI3VDx6WYm7sfuKrXf2JrzBgDz7/tZVE5Bn6nMs5CAhOjh2AlpFFNHm82E698XkbKDEG+aeuAypRV2AMqZke6pDtUi2A4J/eUeJNpT1KSKQIDAQAB'
      }
      if (this.baseDomain === 'oncode')
      {
        key           = 'mailo._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCX3pF0FRzcinxPOcBy3UDcz36/6UjJeeuB7q0EnZEPxvtNE4pL/VgVaBFGp0f/nPuRcSDuX+j7L6LRfcJ1pi/WCWit5gKiwaUN/3s0ChN3alMe58f42VkjqZlJ9tVOFGEepwbI7SvA9GK51zCOIh2tOHn33xUOGxXdie8yLUtwjQIDAQAB'
      }
      if (this.baseDomain === 'constructeurvirtuel')
      {
        key           = 'smtp._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC1lYlfhVdVScKu7rrF1GlUalB5kpI6NpQx1Tbyy/3uQh+i8YMYuR5nRxLSBJt6Ml1TpT0X3wC0AmUz29tE6RUPyqojR6HWiYZLnmlr9dQKtnr86++URs2UfkqSFQgTXL6evh5vHNhEbxvcSc4PvT/DhUytNM0VWiSfeO7I+W2nwwIDAQAB'

        //constructeurvirtuel.com google-site-verification=NjYbrTaoZR15Hw5SvYNbya5un8jMUKsuYxo7yviNGNo
      }
      if (this.baseDomain === 'immofacile')
      {
        key           = 'pic._domainkey'
        expectedValue = 'k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDKEozcDgJvQDeYb95eayl8441PQU93Q5BTOr8adi5qdVfrMtSKtvqHf9Xs+LX2gWU1nl44+mvOExyGUeMSMymvEOp+++sI1QpfHY2TeCDiZxWweCQZcFERdJ9RjZ7F5vg+8dHsxdyIhmNCKQv/qbbrxwYdzU4i6ct4XQedKnZgWQIDAQAB'
      }


      axios.get(this.lookupURL + 'txt/' + key + '.' + this.domain).then(response => {
        let valid        = false
        let currentValue = '[NOT SET]'
        response.data.forEach(data => {
          if (data.txt && data.txt.startsWith('k=rsa;'))
          {
            currentValue = data.txt
          }

        })

        if (currentValue === expectedValue)
        {
          valid = true
        }

        let txtSPF = {
          isValid:       valid,
          domain:        key + '.' + this.domain,
          type:          'TXT',
          currentValue:  currentValue,
          expectedValue: expectedValue,
        }

        this.records.push(txtSPF)
      })
    },
    cnameBAP ()
    {
      axios.get(this.lookupURL + 'cname/bap.' + this.domain).then(response => {
        let valid         = false
        let currentValue  = '[NOT SET]'
        let expectedValue = 'bap-' + this.baseDomain + '.apps.newera.systems'

        if (response.data.length === 0)
        {
          // no-op
        } else if (response.data.length > 1)
        {
          response.data.forEach(data => {
            currentValue += data.target + ' '
          })
        } else
        {
          currentValue = response.data[0].target
        }

        if (currentValue === expectedValue)
        {
          valid = true
        }

        this.records.push({
            isValid:       valid,
            domain:        'bap.' + this.domain,
            type:          'CNAME',
            currentValue:  currentValue,
            expectedValue: expectedValue,
          }
        )
      })
    },
    cnameCOMMUNICATIONS ()
    {
      axios.get(this.lookupURL + 'cname/communications.' + this.domain).then(response => {
        let valid         = false
        let currentValue  = '[NOT SET]'
        let expectedValue = 'subscriptions-manager.apps.newera.systems'

        if (response.data.length === 0)
        {
          // no-op
        } else if (response.data.length > 1)
        {
          response.data.forEach(data => {
            currentValue += data.target + ' '
          })
        } else
        {
          currentValue = response.data[0].target
        }

        if (currentValue === expectedValue)
        {
          valid = true
        }

        this.records.push({
            isValid:       valid,
            domain:        'communications.' + this.domain,
            type:          'CNAME',
            currentValue:  currentValue,
            expectedValue: expectedValue,
          }
        )
      })
    },
    cnameEMAILS ()
    {
      axios.get(this.lookupURL + 'cname/email.' + this.domain).then(response => {
        let valid         = false
        let currentValue  = '[NOT SET]'
        let expectedValue = 'email-' + this.baseDomain + '.apps.newera.systems'

        if (response.data.length === 0)
        {
          // no-op
        } else if (response.data.length > 1)
        {
          response.data.forEach(data => {
            currentValue += data.target + ' '
          })
        } else
        {
          currentValue = response.data[0].target
        }

        if (currentValue === expectedValue)
        {
          valid = true
        }

        this.records.push({
            isValid:       valid,
            domain:        'email.' + this.domain,
            type:          'CNAME',
            currentValue:  currentValue,
            expectedValue: expectedValue,
          }
        )
      })
    },

  }

}

</script>

